import styles from './CardFooter.module.sass';
import LogoIcon_SVG from "@/components/svg/Global/LogoIcon_SVG";
const CardFooter = ({cardNumber}) => {
	return (
		<div className={styles.card_footer}>
			<span>1st Edition</span>
			<span>{cardNumber}</span>

			<div className={styles.cards_logo}>
				<LogoIcon_SVG className={styles.logo}/>
				<span>Cards</span>
			</div>
		</div>
	)
}
export default CardFooter;